import { createApp } from 'vue'
import App from './App.vue'

import { createRouter, createWebHistory } from 'vue-router';
import LoginComponent from './components/LoginView.vue'
import UserComponent from './components/UserView.vue'
import MaintainComponent from './components/MaintainView.vue'
import AgreementComponent from './components/AgreementView.vue'

import axios from 'axios';
import { getLocal } from './util/help';

import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css'; // 引入样式文件

import i18n from '@/util/i18n.js';

import GSignInButton from 'vue-google-signin-button'

axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;

const routes = [
    { 
        path: '/', 
        redirect: '/login' 
    },
    { 
        name: "login",
        path: '/login', 
        component: LoginComponent 
    },
    { 
        name: "agreement",
        path: '/user/agreement', 
        component: AgreementComponent 
    },
    { 
        name: "user",
        path: '/user', 
        component: UserComponent,
        meta: {
            requiresAuth: true, // 需要登录才能访问该路由
        },
    },
    { 
        name: "maintain",
        path: '/maintain', 
        component: MaintainComponent
    }
]


const router = createRouter({
    history: createWebHistory(),
    routes, // short for `routes: routes`
})

router.beforeEach((to, from, next) => {
    console.log(getLocal("auth"))
    if (to.meta.requiresAuth && !getLocal("auth")) {
        next({ name: 'login' })
    } else {
        next()
    }
})


const app = createApp(App)


app.use(GSignInButton);
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.mount('#app')
